import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const OrderList = Loadable(lazy(() => import('views/dashboard/OrderList')));
const Statement = Loadable(lazy(() => import('views/dashboard/Statement')));
const Order = Loadable(lazy(() => import('views/dashboard/Order')));
const OrderView = Loadable(lazy(() => import('views/dashboard/OrderView')));
const Users = Loadable(lazy(() => import('views/dashboard/Users')));
const Companies = Loadable(lazy(() => import('views/dashboard/Companies')));
const Promocodes = Loadable(lazy(() => import('views/dashboard/Promocodes')));
const Chat = Loadable(lazy(() => import('views/dashboard/Chat')));
const OrderStatusesPage = Loadable(lazy(() => import('views/order-statuses-page')));
const EventLog = Loadable(lazy(() => import('views/dashboard/EventLog')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <OrderList />
        },
        {
            path: '/statement',
            element: <Statement />
        },
        {
            path: '/order',
            element: <Order />
        },
        {
            path: '/order-view',
            element: <OrderView />
        },
        {
            path: '/users',
            element: <Users />
        },
        {
            path: '/companies',
            element: <Companies />
        },
        {
            path: '/promocodes',
            element: <Promocodes />
        },
        {
            path: '/chat',
            element: <Chat />
        },
        {
            path: '/order-statuses',
            element: <OrderStatusesPage />
        },
        {
            path: '/eventlog',
            element: <EventLog />
        },
        {
            path: '/dashboard/default',
            element: <DashboardDefault />
        },
        {
            path: '/utils/util-typography',
            element: <UtilsTypography />
        },
        {
            path: '/utils/util-color',
            element: <UtilsColor />
        },
        {
            path: '/utils/util-shadow',
            element: <UtilsShadow />
        },
        {
            path: '/icons/tabler-icons',
            element: <UtilsTablerIcons />
        },
        {
            path: '/icons/material-icons',
            element: <UtilsMaterialIcons />
        },
        {
            path: '/sample-page',
            element: <SamplePage />
        }
    ]
};

export default MainRoutes;
